// import decode from 'jwt-decode';
// import fileSaver from 'file-saver';
import axios from 'axios';
import { SCORE_DEFINATION } from '../../../config';
export default class ScorecardService {
    constructor(domain) {
        this.domain = `${SCORE_DEFINATION}`;
        this.token = localStorage.getItem('id_token');
    }
    
    getScorecardSearchResult(search) {
        const httpHeaders = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json',
            'Authorization': `Bearer ${this.token}`
        };
        if (this.token) {
            return axios({
                method: 'get',
                url: `${this.domain}/scorecard/search/${search}`,
                headers: httpHeaders
            })
        }
    }
    getScorecardDetails(id) {
        const httpHeaders = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json',
            'Authorization': `Bearer ${this.token}`
        }
        return axios({
            method: 'get',
            url: `${this.domain}/scorecard/${id}`,
            headers: httpHeaders
        })
    }
    createScorecard(data) {
        const httpHeaders = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${this.token}`
        };
        return axios({
            method: 'post',
            url: `${this.domain}/scorecard/`,
            data: data,
            headers: httpHeaders
        });
    }

    editScorecard(data) {
        const httpHeaders = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${this.token}`
        };

        return axios({
            method: 'put',
            url: `${this.domain}/scorecard/`,
            data: data,
            headers: httpHeaders
        });
    }

    deleteScorecard(id) {
        const httpHeaders = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${this.token}`
        }
        return axios({
            method: 'delete',
            url: `${this.domain}/scorecard/${id}`,
            headers: httpHeaders
        })
    }
}